module.exports = __webpack_public_path__ + "img/1x.4b88de0.jpg";